import { Point } from "@opstel/geo/Point";
import { Orientation } from "@opstel/query/v2/models/action";
import { ShuntingUnit } from "@opstel/query/models/shuntingUnit";
import { DirectionalList } from "@opstel/query/models/types/directionalList";
import { Length } from "@shared/common/utils/length";
import {
  CutLineStrategy,
  CutLineStrategyPart,
} from "@opstel/geo/GetLinePartsStrategies/CutLineStrategy";
import { Path } from "@opstel/geo/Path";
import { StablingInfra } from "@opstel/query/models/location";

export type PlanTrainUnitPath = Point[];
export function calculatePositionOnTrack(
  track: StablingInfra,
  shuntingUnit: ShuntingUnit,
  distanceToSource: Length,
  orientation: Orientation,
): DirectionalList<PlanTrainUnitPath> {
  const ratioToSource = distanceToSource.inMillimeters() / track.length.inMillimeters();
  const strategy = new CutLineStrategy([
    { type: "ratio", value: ratioToSource },
    ...shuntingUnit.planTrainUnits
      .fromSourceToTarget(orientation)
      .map<CutLineStrategyPart>((ptu) => ({
        type: "ratio",
        value: ptu.length.inMillimeters() / track.length.inMillimeters(),
      })),
    { type: "*" },
  ]);
  const segments = new Path(track.coordinates.fromSourceToTarget).getPathSegments(strategy);
  return new DirectionalList(segments.slice(1, -1).map((segment) => segment.path.points));
}
